module.exports = __webpack_public_path__ + "static/media/S3N9-1.95e6ddb4.svg";